import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TeamCompiPage from "./TeamCompiPage";
import SoloCompiPage from "./SoloCompiPage";
import jwtDecode from "jwt-decode";

const CompiPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { compId } = params;

  const [competition, setCompetition] = useState({});

  const [user, setUser] = useState(
    localStorage.getItem("compiauthtoken")
      ? jwtDecode(localStorage.getItem("compiauthtoken")).user
      : null
  );

  const fetchCompetitionDetails = () => {
    Axios.get(
      `https://ashish.moodi.org/multicity/get_compi_details?id=${compId}`
    )
      .then((res) => setCompetition(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (localStorage.getItem("compiauthtoken")) {
      fetchCompetitionDetails();
    } else {
      navigate("/admin/login");
    }
    // eslint-disable-next-line
  }, []);
  return (
    <div className="container-fluid">
      {competition.isTeamCompi ? (
        <TeamCompiPage
          user={user}
          competition={competition}
          setCompetition={setCompetition}
        />
      ) : (
        <SoloCompiPage
          user={user}
          competition={competition}
          setCompetition={setCompetition}
        />
      )}
    </div>
  );
};

export default CompiPage;
